import { render, staticRenderFns } from "./TabsDashboardAdd.vue?vue&type=template&id=8ae7e430&"
import script from "./TabsDashboardAdd.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports